import angular from 'angular';
import uiRouter from 'angular-ui-router';

import profileModule from './screens/settings-profile';
import contactModule from './screens/settings-contact';
import passwordModule from './screens/settings-password';
import expertisesModule from './screens/settings-expertises';
import certificationsModule from './screens/settings-certifications';
import educationalAchievementsModule from './screens/settings-educational-achievements';
import recognitionsModule from './screens/settings-recognitions';

import ProfileFactory from 'profile.factory';
import settingsNavComponent from 'settings-nav';
import tagFormComponent from 'tag-form';
import settingsComponent from './settings.component';

const settingsModule = angular.module('settings', [
  uiRouter,
  profileModule.name,
  contactModule.name,
  passwordModule.name,
  expertisesModule.name,
  certificationsModule.name,
  educationalAchievementsModule.name,
  recognitionsModule.name,
])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $stateProvider
      .state('engineer.settings', {
        url: '/settings',
        abstract: true,
        template: '<settings profile="$resolve.profile" class="settings"></settings>',
        resolve: {
          profile: function(Profile) {
            return Profile.query().$promise;
          },
        }
      });
  })
  .factory('Profile', ProfileFactory)
  .component('tagForm', tagFormComponent)
  .component('settingsNav', settingsNavComponent)
  .component('settings', settingsComponent);

export default settingsModule;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/settings/index.js